import React from 'react';

import { useTranslation } from 'react-i18next';

import { InputPopover } from '../components/InputPopover';

export function LabelInputPopover({ ...props }) {
  const { t } = useTranslation();

  return (
    <InputPopover
      fieldLabel={t('label')}
      fieldName="top_matching_candidates_label"
      testId="top_matching_candidates_Filter"
      {...props}
    />
  );
}
